/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedBlurbLeadTime_item = {
    readonly isNewAndMadeToOrder: boolean | null;
    readonly attributes: {
        readonly leadTime: ReadonlyArray<{
            readonly option: {
                readonly name: string | null;
                readonly urlLabel: string | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": "PdpSharedBlurbLeadTime_item";
};
export type PdpSharedBlurbLeadTime_item$data = PdpSharedBlurbLeadTime_item;
export type PdpSharedBlurbLeadTime_item$key = {
    readonly " $data"?: PdpSharedBlurbLeadTime_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedBlurbLeadTime_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedBlurbLeadTime_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isNewAndMadeToOrder",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "attributes",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemAttributes",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "leadTime",
          "storageKey": null,
          "args": null,
          "concreteType": "AttributeValue",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "option",
              "storageKey": null,
              "args": null,
              "concreteType": "AttributeOption",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "name",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "urlLabel",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '664473f3594e3c556a4e8f898364c7a9';
export default node;
